import { Link } from 'react-router-dom';

const AuthLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  return (
    <Link to={to} style={{ textDecoration: 'none', fontWeight: 500 }}>
      {children}
    </Link>
  );
};

export default AuthLink;
